import React from 'react';
import { KyowaKirinWordmark } from './concept/KyowaKirinWordmark';
import { SnakkerLogo } from './SnakkerLogo';
export type View = 'main' | 'insights';
type PresentationBarProps = {
  view: View;
  onOpenInsights: () => void;
  onHome: () => void;
};
export function PresentationBar({
  view,
  onOpenInsights,
  onHome
}: PresentationBarProps) {
  return <div className="relative z-30 shrink-0 border-b border-rule bg-white" data-id="element-655" data-mp="36vwq4q66baa3">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-5 md:px-8" data-id="element-656" data-mp="2a9bbrgoj9env">
        <div className="flex min-w-0 items-center gap-5" data-id="element-657" data-mp="2f7342bt3b2sl">
          <button type="button" onClick={onHome} aria-label="Snakker for Kyowa Kirin — back to the presentation" className="flex items-center gap-3 rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy" data-id="element-658" data-mp="2j86h6qjr6kq4">
            <SnakkerLogo data-id="element-659" data-mp="1vhj5rvampcyt" />
            <span className="text-[13px] text-graphite/60" aria-hidden="true" data-id="element-660" data-mp="1vgraklky1h92">
              ×
            </span>
            <KyowaKirinWordmark data-id="element-661" data-mp="1mbicrmhfiun0" />
          </button>
          <span className="hidden h-7 w-px bg-rule lg:block" aria-hidden="true" data-id="element-662" data-mp="1mctezhv87uc0" />
          <p className="hidden truncate font-mono text-[11px] tracking-[0.24em] text-graphite/70 lg:block" data-id="element-663" data-mp="1hk0fb8em7c6s">
            ILLUSTRATIVE CONCEPT
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2" data-id="element-664" data-mp="17mm8m0ihu1ro">
          <button type="button" onClick={onOpenInsights} aria-pressed={view === 'insights'} className={`inline-flex items-center whitespace-nowrap rounded-full border px-4 py-2.5 text-[13px] font-medium transition-[background-color,border-color,color,transform] duration-150 ease-out active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy sm:px-5 sm:text-sm ${view === 'insights' ? 'border-teal bg-teal text-white' : 'border-ink/20 bg-white text-ink hover:border-ink'}`} data-id="element-665" data-mp="17o5m5jcrlypr">
            Insights &amp; Learnings
          </button>
        </div>
      </div>
    </div>;
}